function Terms() {
  return (
    <div className="p-6 max-w-4xl mx-auto">
      <h1 className="text-3xl font-bold mb-6">Terms of Use</h1>

      <p className="mb-4">
        Welcome to JobBoard. These terms and conditions outline the rules and regulations for the use of our website and services.
      </p>

      <h2 className="text-xl font-semibold mt-4 mb-2">1. Acceptance of Terms</h2>
      <p className="mb-4">
        By accessing or using JobBoard, you agree to be bound by these Terms of Use. If you do not agree, please do not use the platform.
      </p>

      <h2 className="text-xl font-semibold mt-4 mb-2">2. Use of the Platform</h2>
      <p className="mb-4">
        You may use the platform for lawful purposes only. You must not misuse the platform in any way that could harm other users or the service itself.
      </p>

      <h2 className="text-xl font-semibold mt-4 mb-2">3. User Accounts</h2>
      <p className="mb-4">
        You are responsible for maintaining the confidentiality of your account credentials. JobBoard is not liable for any loss or damage arising from your failure to protect your login information.
      </p>

      <h2 className="text-xl font-semibold mt-4 mb-2">4. Job Postings & Applications</h2>
      <p className="mb-4">
        Employers are solely responsible for the accuracy and legitimacy of job postings. Candidates are responsible for the content of their applications and resumes.
      </p>

      <h2 className="text-xl font-semibold mt-4 mb-2">5. Termination</h2>
      <p className="mb-4">
        We reserve the right to suspend or terminate your account if we suspect any misuse or violation of these terms.
      </p>

      <h2 className="text-xl font-semibold mt-4 mb-2">6. Changes to Terms</h2>
      <p className="mb-4">
        We may update these terms from time to time. Continued use of the platform after changes implies acceptance of the new terms.
      </p>

      <p className="mt-6 text-sm text-gray-600">
        Last updated: July 23, 2025
      </p>
    </div>
  );
}

export default Terms;
